/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsForSaasOtherServices extends models.FilterOptionsForSaasBase {
    getFixupPrototypeFunction() { return FilterOptionsForSaasOtherServices.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsForSaasOtherServices>): FilterOptionsForSaasOtherServices {
        let obj = Object.assign(new FilterOptionsForSaasOtherServices(), model);
        FilterOptionsForSaasOtherServices.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsForSaasOtherServices>): FilterOptionsForSaasOtherServices {
        if (!model) return null;
        return FilterOptionsForSaasOtherServices.newInstance(<FilterOptionsForSaasOtherServices> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsForSaasOtherServices) {
        if (!obj) return;

        models.FilterOptionsForSaasOtherServices.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsForSaasOtherServices): boolean {
        if (models.FilterOptionsForSaasBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsForSaasOtherServices.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of SaaS services supported for the role template
     */
    saas: models.SaasOtherServiceName;

}
